module.exports = __webpack_public_path__ + "static/media/streetCorrect.b43aeb50.png";